module.exports = __webpack_public_path__ + "static/media/bt_top_mofftre_over.7f58753e.png";